const menuConfig = [
  {
    name: 'menus',
    path: '/menus',
    options: [
      {
        name: 'tabs',
        path: '/tabs',
      },
    ],
  },
];

export default menuConfig;
